// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.GetConfigWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  GetConfigWebApiHandler_getConfig,
  GetConfigWebApiHandler_getConfig_Path,
} from '@zg-rentals/ts-rent-payment-client';

import type { GetConfigRequestDto, GetConfigResponseDto } from '@zg-rentals/ts-rent-payment-client';

export type GetConfigWebApiHandler_getConfig_Options = UseQueryOptions<
  GetConfigResponseDto,
  unknown,
  GetConfigResponseDto,
  readonly [string, GetConfigRequestDto]
>;

const GetConfigWebApiHandler_getConfig_GetKey = (postData: GetConfigRequestDto) =>
  [GetConfigWebApiHandler_getConfig_Path, postData] as const;

export const GetConfigWebApiHandler_getConfig_queryOptions = (
  postData: GetConfigRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: GetConfigWebApiHandler_getConfig_GetKey(postData),
    queryFn: () => GetConfigWebApiHandler_getConfig(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get config
 */
export const useGetConfigWebApiHandler_getConfig = (
  postData: GetConfigRequestDto,
  {
    httpClient,
    ...options
  }: Omit<GetConfigWebApiHandler_getConfig_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...GetConfigWebApiHandler_getConfig_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useGetConfigWebApiHandler_getConfig.getKey = GetConfigWebApiHandler_getConfig_GetKey;
